import {AddressEntity} from "@dropDesk/domain/entities/common/address.entity";

export class CNPJResponseEntity {
  name!: string;
  socialName!: string;
  friendlyName?: string;
  doc!: string;
  email?: string;
  phone?: string;
  address?: AddressEntity;
  clientAlreadyExists?: boolean;
  error?: string;

  constructor({
                name,
                socialName,
                friendlyName,
                doc,
                email,
                phone,
                address,
                clientAlreadyExists,
                error,
              }: {
    name: string;
    socialName: string;
    friendlyName?: string;
    doc: string;
    email?: string;
    phone?: string;
    address?: AddressEntity;
    clientAlreadyExists?: boolean;
    error?: string;
  }) {
    Object.assign(this, {
      name,
      socialName,
      doc,
      friendlyName,
      email,
      phone,
      address,
      clientAlreadyExists,
      error,
    });
  }

  copyWith({
             name,
             socialName,
             doc,
             friendlyName,
             email,
             phone,
             address,
             clientAlreadyExists,
             error,
           }: {
    name?: string;
    socialName?: string;
    friendlyName?: string;
    doc?: string;
    email?: string;
    phone?: string;
    address?: AddressEntity;
    clientAlreadyExists?: boolean;
    error?: string;
  }): CNPJResponseEntity {
    return new CNPJResponseEntity({
      name: name ?? this.name,
      socialName: socialName ?? this.socialName,
      friendlyName: friendlyName ?? this.friendlyName,
      doc: doc ?? this.doc,
      email: email ?? this.email,
      phone: phone ?? this.phone,
      address: address ?? this.address,
      clientAlreadyExists: clientAlreadyExists ?? this.clientAlreadyExists,
      error: error ?? this.error,
    })
  }

}
